import { createTheme, darken, lighten } from '@mui/material/styles'
import type { ThemeOptions } from '@mui/material/styles'
import { brandedTokens } from './tokens';

export const brandedComponents: ThemeOptions['components'] = {
    MuiAppBar: {
        styleOverrides: {
            root: ({ theme }) => ({
                backgroundColor: theme.palette.background.default,
                color: theme.palette.primary.dark,
                borderBottom: `1px solid ${theme.palette.background.default}`,
                boxShadow: 'none',
                fontFamily: 'inherit',
                '& .MuiIconButton-root': {
                    width: 36,
                    height: 36,
                    backgroundColor: lighten(theme.palette.primary.light, 0.9),
                    '&:hover': {
                        backgroundColor: lighten(
                            theme.palette.primary.light,
                            0.8
                        ),
                    },
                },
            }),
        },
    },
};

export const theme = createTheme({
    ...brandedTokens,
    components: brandedComponents,
})
